(function () {
  'use strict';

  function formatCardPrice(cents) {
    var amount = Number(cents || 0) / 100;
    if (!isFinite(amount)) return '';

    return amount % 1 === 0
      ? Math.round(amount).toLocaleString('en-IN')
      : amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function syncOfferPrice(card, selectedItem) {
    if (!selectedItem) return;

    var price = Number(selectedItem.getAttribute('data-price'));
    var compare = Number(selectedItem.getAttribute('data-compare'));
    if (!isFinite(price)) return;

    var currentPrice = card.querySelector('.product-card__current-price');
    var comparePrice = card.querySelector('.product-card__compare-price');
    var discountPill = card.querySelector('.product-card__discount-pill');

    if (currentPrice) {
      currentPrice.textContent = '\u20B9' + formatCardPrice(price);
    }

    if (comparePrice) {
      if (isFinite(compare) && compare > price) {
        comparePrice.textContent = '\u20B9' + formatCardPrice(compare);
        comparePrice.style.display = '';
      } else {
        comparePrice.style.display = 'none';
      }
    }

    if (discountPill) {
      if (isFinite(compare) && compare > price) {
        var discount = Math.round(((compare - price) * 100) / compare);
        discountPill.textContent = discount + '% OFF';
        discountPill.style.display = 'inline-flex';
      } else {
        discountPill.style.display = 'none';
      }
    }
  }

  function syncMobileOfferNote(card) {
    var select = card.querySelector('.figma-offer-mobile__select');
    if (!select) return;

    var selectedOption = select.options[select.selectedIndex];
    var selectedText = selectedOption
      ? (selectedOption.getAttribute('data-option-value') || selectedOption.textContent).trim().toLowerCase()
      : '';
    var recommendedNote = card.querySelector('.figma-offer-mobile__note[data-offer-note="recommended"]');
    var bestValueNote = card.querySelector('.figma-offer-mobile__note[data-offer-note="best-value"]');

    if (recommendedNote) {
      recommendedNote.classList.toggle('is-visible', selectedText.indexOf('pack of 2') !== -1);
    }

    if (bestValueNote) {
      bestValueNote.classList.toggle('is-visible', selectedText.indexOf('pack of 3') !== -1);
    }
  }

  function syncOfferSelection(card) {
    var selectedItem = null;

    card.querySelectorAll('.figma-offer-desktop .HorizontalList__Item').forEach(function (item) {
      var radio = item.querySelector('.SizeSwatch__Radio');
      if (!radio) return;

      var isSelected = radio.checked;
      item.classList.toggle('figma-offer-selected', isSelected);

      if (isSelected) selectedItem = item;
    });

    if (selectedItem) syncOfferPrice(card, selectedItem);
    syncMobileOfferNote(card);
  }

  function updateVariantId(card, variantId) {
    card.querySelectorAll('form input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
  }

  function handleOfferChange(event) {
    var target = event.target;
    var card = target.closest('product-card');
    if (!card) return;

    if (target.matches('.figma-offer-mobile__select')) {
      syncMobileOfferNote(card);
      updateVariantId(card, target.value);
      syncOfferPrice(card, target.options[target.selectedIndex]);
      return;
    }

    if (target.matches('.figma-offer-desktop .SizeSwatch__Radio')) {
      syncOfferSelection(card);
    }
  }

  function handleOfferClick(event) {
    var target = event.target;
    var card = target.closest('product-card');
    if (!card) return;

    var box = target.closest('.figma-offer-desktop .lbl_outer');
    if (!box || !card.contains(box)) return;

    if (target.closest('label')) {
      window.setTimeout(function () {
        syncOfferSelection(card);
      }, 0);
      return;
    }

    var radio = box.querySelector('.SizeSwatch__Radio');
    if (!radio) return;

    if (target !== radio) radio.click();
    window.setTimeout(function () {
      syncOfferSelection(card);
    }, 0);
  }

  var sliders = [];
  var sliderTimer = null;
  var sliderObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var state = entry.target.__productCardSlider;
          if (state) state.visible = entry.isIntersecting;
        });
      })
    : null;

  function sliderHeight(state) {
    return state.viewport.getBoundingClientRect().height;
  }

  function moveSlider(state, nextIndex, animate) {
    state.track.style.transition = animate
      ? 'transform 500ms cubic-bezier(0.22, 0.61, 0.36, 1)'
      : 'none';
    state.track.style.transform =
      'translate3d(0, -' + (nextIndex * sliderHeight(state)) + 'px, 0)';
  }

  function advanceSlider(state) {
    if (state.locked) return;
    state.locked = true;
    state.index += 1;
    moveSlider(state, state.index, true);

    if (state.index === state.slides.length) {
      window.setTimeout(function () {
        state.track.style.transition = 'none';
        state.index = 0;
        moveSlider(state, 0, false);

        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            state.locked = false;
          });
        });
      }, 520);
    } else {
      window.setTimeout(function () {
        state.locked = false;
      }, 520);
    }
  }

  function tickSliders() {
    for (var i = sliders.length - 1; i >= 0; i -= 1) {
      var state = sliders[i];
      if (!state.badge.isConnected) {
        if (sliderObserver) sliderObserver.unobserve(state.badge);
        delete state.badge.__productCardSlider;
        sliders.splice(i, 1);
        continue;
      }

      if (state.visible) advanceSlider(state);
    }

    if (sliders.length === 0 && sliderTimer) {
      window.clearInterval(sliderTimer);
      sliderTimer = null;
    }
  }

  function initializeSliders(card) {
    card.querySelectorAll('.pro_image_badge[data-slide-count]').forEach(function (badge) {
      if (badge.__productCardSlider) return;

      var viewport = badge.querySelector('.pro_image_badge__viewport');
      var track = badge.querySelector('.pro_image_badge__track');
      if (!viewport || !track) return;

      var slides = Array.prototype.slice.call(
        track.querySelectorAll('.pro_image_badge__slide:not(.pro_image_badge__slide--clone)')
      );
      if (slides.length <= 1) return;

      var oldClone = track.querySelector('.pro_image_badge__slide--clone');
      if (oldClone) oldClone.remove();

      var clone = slides[0].cloneNode(true);
      clone.classList.add('pro_image_badge__slide--clone');
      track.appendChild(clone);

      var state = {
        badge: badge,
        viewport: viewport,
        track: track,
        slides: slides,
        index: 0,
        locked: false,
        visible: !sliderObserver
      };

      badge.__productCardSlider = state;
      sliders.push(state);
      moveSlider(state, 0, false);
      if (sliderObserver) sliderObserver.observe(badge);
      if (!sliderTimer) sliderTimer = window.setInterval(tickSliders, 2500);
    });
  }

  function refreshSliderPositions() {
    sliders.forEach(function (state) {
      moveSlider(state, state.index, false);
    });
  }

  function initializeCard(card) {
    if (card.hasAttribute('data-ready')) return;
    syncOfferSelection(card);
    initializeSliders(card);
    card.setAttribute('data-ready', 'true');
  }

  function initializeUnreadyCards(root) {
    root.querySelectorAll('product-card:not([data-ready])').forEach(initializeCard);
  }

  document.addEventListener('change', handleOfferChange);
  document.addEventListener('click', handleOfferClick);

  var resizeFrame;
  window.addEventListener('resize', function () {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(refreshSliderPositions);
  }, { passive: true });

  function start() {
    initializeUnreadyCards(document);

    if (document.body && 'MutationObserver' in window) {
      var scheduled = false;
      var cardObserver = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          initializeUnreadyCards(document);
        });
      });
      cardObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
